import { DialogType, ModalType, SimpleDialogParams } from '../../../../../interfaces/simple-dialog';
import { FormAPI, ModalService, TextAreaAPI, ToastService } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { DressingsInactivateAliases, FragmentNames } from '../../../../../codegen';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../../constants/endpoints';
import { Value } from '@philips-internal/oswald-ui-core';
import { SimpleDialog } from '../../../../dialog-helper';
import BaseController from '../../../../BaseController';
import { Inject } from '@odinjs/odin';

@Controller({ fragment: FragmentNames.DRESSINGS_INACTIVATE })
export default class DressingsInactivateController extends BaseController {

  @Inject(DressingsInactivateAliases.FORM_DRESSINGS_INACTIVATE)
  private formAPI!: FormAPI;

  @Inject(DressingsInactivateAliases.TEXT_AREA_JUSTIFY)
  private textAreaAPI!: TextAreaAPI;

  private inactivateDressings(endpoint: string): void {
    const { dressingId } = this.historyService.getCurrentRouteParams();
    const justification = this.textAreaAPI.getValue();

    this.formAPI.setLoading(true);

    const body = { justification, woundsDressingsId: dressingId, } as Record<string, Value>;

    HttpService.put(endpoint, undefined, {body})
      .then(() => {
        this.historyService.back();
        this.showMessageDialog('title.disable-record', 'patient-evolution.successfully-inactivated-message');
      }).catch((err) => {
        err?.body && this.showToast(err?.body, ToastLevel.ERROR);
      }).finally(() => {
        this.formAPI.setLoading(false);
      })
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'wounds-dressings-inactivate',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private showMessageDialog(title: string, description: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: (): void => ModalService.close(FragmentNames.DRESSINGS_INACTIVATE),
      titleDialog: title,
      titleOnOk: 'OK',
    }
    SimpleDialog.openDialog(dialogParams);
  }

  @OnCancel({ target: DressingsInactivateAliases.FORM_DRESSINGS_INACTIVATE })
  handleCancelForm(): void {
    ModalService.close(FragmentNames.DRESSINGS_INACTIVATE);
  }

  @OnBeforeSubmit({ target: DressingsInactivateAliases.FORM_DRESSINGS_INACTIVATE })
  handleBeforeSubmit(): void {
    this.inactivateDressings(Endpoint.INACTIVATE_DRESSING);
  }
}